import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function HangarBarOpen() {
  const dateTexts = ['1938年'];
  const title = 'ジョックリンゼイがディズニースプリングスに定住する';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/jock-lindseys-hangar-bar-g00.jpg'
  const description = (
    <>
      {'水上飛行機のパイロットであり、S.E.A.会員の'}
      <a href='/jock-lindsey'>
        {'ジョックリンゼイ'}
      </a>
      {'が、インディジョーンズと共にディズニースプリングスを発見する。'}
      {'リンゼイはこの土地を気に入り、水辺の土地を購入し水上飛行ツアーを開始する。'}
      {'さらに飛行機の格納庫を利用した'}
      <a href='/hangar-bar'>
        {'ダイニングバー'}
      </a>
      {'をオープンし、S.E.A.会員たちや旅行者たちが訪れる人気のバーとなる。'}
    </>
  );
  const quoteDomain = 'disneyworld.disney.go.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default HangarBarOpen;
